import { render, staticRenderFns } from "./group-project-list.vue?vue&type=template&id=b78dd38e"
import script from "./group-project-list.vue?vue&type=script&lang=js"
export * from "./group-project-list.vue?vue&type=script&lang=js"
import style0 from "./group-project-list.vue?vue&type=style&index=0&id=b78dd38e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports